import React from 'react';
import COLORS from 'assets/styles/colors';

import type { IIconProps } from 'infrastructure/interfaces';
import type { Nullable } from 'infrastructure/types';

const level0: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 6C0.5 4.89543 1.39543 4 2.5 4H12.5C13.6046 4 14.5 4.89543 14.5 6V10C14.5 11.1046 13.6046 12 12.5 12H2.5C1.39543 12 0.5 11.1046 0.5 10V6ZM2.5 5C1.94772 5 1.5 5.44772 1.5 6V10C1.5 10.5523 1.94772 11 2.5 11H12.5C13.0523 11 13.5 10.5523 13.5 10V6C13.5 5.44772 13.0523 5 12.5 5H2.5Z"
        fill={color}
      />
      <path
        d="M16.5 8C16.5 8.82843 15.8284 9.5 15 9.5V6.5C15.8284 6.5 16.5 7.17157 16.5 8Z"
        fill={color}
      />
    </svg>
  );
};

const level1: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 6H4.5V10H2.5V6Z" fill={color} />
      <path
        d="M2.5 4C1.39543 4 0.5 4.89543 0.5 6V10C0.5 11.1046 1.39543 12 2.5 12H12.5C13.6046 12 14.5 11.1046 14.5 10V6C14.5 4.89543 13.6046 4 12.5 4H2.5ZM12.5 5C13.0523 5 13.5 5.44772 13.5 6V10C13.5 10.5523 13.0523 11 12.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V6C1.5 5.44772 1.94772 5 2.5 5H12.5Z"
        fill={color}
      />
      <path
        d="M16.5 8C16.5 8.82843 15.8284 9.5 15 9.5V6.5C15.8284 6.5 16.5 7.17157 16.5 8Z"
        fill={color}
      />
    </svg>
  );
};

const level2: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 6H7.5V10H2.5V6Z" fill={color} />
      <path
        d="M2.5 4C1.39543 4 0.5 4.89543 0.5 6V10C0.5 11.1046 1.39543 12 2.5 12H12.5C13.6046 12 14.5 11.1046 14.5 10V6C14.5 4.89543 13.6046 4 12.5 4H2.5ZM12.5 5C13.0523 5 13.5 5.44772 13.5 6V10C13.5 10.5523 13.0523 11 12.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V6C1.5 5.44772 1.94772 5 2.5 5H12.5Z"
        fill={color}
      />
      <path
        d="M16.5 8C16.5 8.82843 15.8284 9.5 15 9.5V6.5C15.8284 6.5 16.5 7.17157 16.5 8Z"
        fill={color}
      />
    </svg>
  );
};

const level3: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 6H10.5V10H2.5V6Z" fill={color} />
      <path
        d="M2.5 4C1.39543 4 0.5 4.89543 0.5 6V10C0.5 11.1046 1.39543 12 2.5 12H12.5C13.6046 12 14.5 11.1046 14.5 10V6C14.5 4.89543 13.6046 4 12.5 4H2.5ZM12.5 5C13.0523 5 13.5 5.44772 13.5 6V10C13.5 10.5523 13.0523 11 12.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V6C1.5 5.44772 1.94772 5 2.5 5H12.5Z"
        fill={color}
      />
      <path
        d="M16.5 8C16.5 8.82843 15.8284 9.5 15 9.5V6.5C15.8284 6.5 16.5 7.17157 16.5 8Z"
        fill={color}
      />
    </svg>
  );
};

const level4: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 6H12.5V10H2.5V6Z" fill={color} />
      <path
        d="M2.5 4C1.39543 4 0.5 4.89543 0.5 6V10C0.5 11.1046 1.39543 12 2.5 12H12.5C13.6046 12 14.5 11.1046 14.5 10V6C14.5 4.89543 13.6046 4 12.5 4H2.5ZM12.5 5C13.0523 5 13.5 5.44772 13.5 6V10C13.5 10.5523 13.0523 11 12.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V6C1.5 5.44772 1.94772 5 2.5 5H12.5Z"
        fill={color}
      />
      <path
        d="M16.5 8C16.5 8.82843 15.8284 9.5 15 9.5V6.5C15.8284 6.5 16.5 7.17157 16.5 8Z"
        fill={color}
      />
    </svg>
  );
};

const charging: React.FC<IBatteryIconProps> = ({
  color = COLORS.BUOYANT,
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.58473 2.56781C9.78575 2.68472 9.87962 2.9248 9.81123 3.14706L8.67701 6.83332H10.6667C10.8662 6.83332 11.0466 6.95189 11.1257 7.135C11.1843 7.27055 11.179 7.42226 11.1169 7.55085C11.1056 7.57428 11.0924 7.59694 11.0774 7.61859C11.0634 7.63866 11.0479 7.65787 11.0308 7.67603L5.69744 13.3427C5.53807 13.512 5.28298 13.5491 5.08196 13.4322C4.88094 13.3153 4.78707 13.0752 4.85546 12.853L5.9897 9.16668H4.00001C3.80053 9.16668 3.62014 9.04811 3.54102 8.865C3.46901 8.69833 3.49344 8.50721 3.60149 8.3647C3.61216 8.35063 3.62365 8.33703 3.63593 8.32397L8.96924 2.65733C9.12862 2.48799 9.38371 2.45089 9.58473 2.56781Z"
        fill={color}
      />
      <path
        d="M2 4H6.3323L5.39113 5H2C1.44772 5 1 5.44772 1 6V10C1 10.5523 1.44772 11 2 11H4.37935L4.07165 12H2C0.89543 12 0 11.1046 0 10V6C0 4.89543 0.895431 4 2 4Z"
        fill={color}
      />
      <path
        d="M2 6H4.44995L2.90773 7.63861C2.49759 8.07438 2.38571 8.71226 2.62307 9.2616C2.76358 9.5868 3.01055 9.84414 3.31285 10H2V6Z"
        fill={color}
      />
      <path
        d="M10.5951 4L10.2874 5H12C12.5523 5 13 5.44772 13 6V10C13 10.5523 12.5523 11 12 11H9.27558L8.3344 12H12C13.1046 12 14 11.1046 14 10V6C14 4.89543 13.1046 4 12 4H10.5951Z"
        fill={color}
      />
      <path
        d="M12 10H10.2168L11.759 8.36137C11.8564 8.25791 11.9369 8.14306 12 8.02071V10Z"
        fill={color}
      />
      <path
        d="M12 6.64603V6H11.3539C11.627 6.1408 11.8549 6.36441 12 6.64603Z"
        fill={color}
      />
      <path
        d="M16 8C16 8.82843 15.3284 9.5 14.5 9.5V6.5C15.3284 6.5 16 7.17157 16 8Z"
        fill={color}
      />
    </svg>
  );
};

interface IBatteryIconProps extends IIconProps {
  level?: Nullable<number>;
}

const BatteryIcon: React.FC<IBatteryIconProps> = (props) => {
  const { level = 0 } = props;

  let icon = level0(props);

  if (level) {
    if (level > 0) {
      icon = level1(props);
    }
    if (level > 3) {
      icon = level2(props);
    }
    if (level > 5) {
      icon = level3(props);
    }
    if (level > 8) {
      icon = level4(props);
    }
    if (level === 11) {
      icon = charging(props);
    }
  }

  return icon;
};

export default BatteryIcon;
